import { Component, Input } from '@angular/core';
import { Direction } from '../../types/direction';

const rotateMapping = {
  down: 'rotate(0deg)',
  up: 'rotate(180deg)',
  left: 'rotate(90deg)',
  right: 'rotate(270deg)',
};

@Component({
  selector: 'app-icon-caret',
  templateUrl: './icon-caret.component.html',
  styleUrls: ['./icon-caret.component.scss'],
  standalone: true,
})
export class IconCaretComponent {
  @Input() color = '#E8EEF2';
  @Input() width = '16';
  @Input() height = '16';
  @Input() set direction(direction: Direction) {
    this.rotate = this.getRotateMapping(direction);
  }
  rotate: string = rotateMapping.down;

  getRotateMapping(direction: string) {
    return rotateMapping[direction] || rotateMapping.down;
  }
}
